/**
 * Preview › ALM (screens §2.4): the Bank › Risk › ALM page in the panel's narrow layout, the year's start beside your draft at year-end.
 */
import { useRoute } from "../../api/context";
import { Alm } from "../../financials/Alm";
import "../../financials/financials.css";
import { GxLoading } from "../../theme/GxLoading";
import type { PreviewViewProps } from "../slotTypes";

export function AlmView({ state, teamId, riskProjection }: PreviewViewProps) {
  const position = useRoute("bankPosition", { teamId });
  const team = useRoute("teamState", { teamId });
  if (state.status === "error") return <p className="gx-decide-pv-note gx-muted">Preview unavailable. Your decisions are saved.</p>;
  const draft = state.status === "ready" ? state.result.horizon?.alm : undefined;
  if (position.data === undefined || draft === undefined) return <div className="gx-decide-pv-note" data-testid="decide.alm.working"><GxLoading words="Working out your rate position…" height={72} /></div>;
  return (
    <div className="gx-decide-pv-alm" data-testid="decide.alm">
      <p className="gx-small gx-faint">Where you sit on rates now (round start), and what your plan makes of it by year-end.</p>
      <Alm alm={position.data.alm} draft={draft} projection={riskProjection} narrow lastRound={team.data?.cohort.roundCount} />
    </div>
  );
}
